var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _rect, _path7, _rect2, _polygon2, _path8, _path9, _path10, _path11, _path12, _path13, _rect3, _rect4, _rect5, _rect6, _rect7, _path14, _path15, _rect8, _rect9, _rect10, _path16, _path17, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _polygon3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse, _ellipse2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g, _path39, _path40, _path41, _path42, _path43, _circle, _circle2, _path44, _path45, _path46, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g2, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _polygon4, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _g3, _ellipse3, _rect35, _path97, _polygon5, _polygon6, _polygon7, _path98, _path99, _path100, _path101, _path102, _path103;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewDoctor1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ccdb08d7-40f3-45f2-8ef6-c6a673654779",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1167.61,
    height: 862.87,
    viewBox: "0 0 1167.61 862.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb66075b-2ebe-455c-893b-1def13a8d59c",
    x1: 481.48,
    y1: 854.12,
    x2: 481.48,
    y2: 276.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b7415561-023b-44da-badb-9b3453976a8a",
    x1: 878.34,
    y1: 879.41,
    x2: 878.34,
    y2: 264.07,
    xlinkHref: "#cb66075b-2ebe-455c-893b-1def13a8d59c"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doctors") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.37,356.76H193.85V495.09H99.79c-.24,1.43-.48,2.85-.75,4.28h94.81V610.91c-.16,0-.32-.12-.47-.18q-4-1.59-8-3.37c-.57-.26-1.13-.53-1.71-.78q-4-1.89-8-4c-.93-.49-1.86-1-2.77-1.52A166.43,166.43,0,0,1,133,570c-.35-.33-.67-.69-1-1-1.62-1.76-3.21-3.54-4.75-5.36-.58-.67-1.14-1.35-1.71-2-1.82-2.22-3.58-4.52-5.28-6.83-.26-.35-.5-.69-.75-1a147.72,147.72,0,0,1-17.2-31.1c-.14-.33-.27-.69-.4-1-1.38-3.5-2.63-7.05-3.71-10.67-.46-1.51-.91-3-1.29-4.57-.14-.45-.25-.91-.37-1.36-5.62-22.15-6.27-45.17-6.27-68.08q0-4,0-8Q90.39,415,90.6,401q.08-3.6.15-7.23.21-9.19.6-18.42c.06-1.7.14-3.41.23-5.1q.06-1.47.15-2.94Q92,362,92.37,356.76Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.85,202.74H138.18A423.75,423.75,0,0,1,167.79,162c8.28-10.16,17-20.06,26.06-29.6Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.85,207V352.48H92.69c0-.42.06-.85.1-1.27.09-1.15.18-2.29.28-3.44.1-1.34.23-2.68.36-4s.26-2.92.42-4.37.29-2.92.45-4.37.32-2.9.5-4.34.34-2.9.54-4.34c.15-1.19.3-2.39.47-3.59.23-1.69.47-3.38.72-5.06,0-.26.08-.51.12-.76a348.93,348.93,0,0,1,7.44-36.52,270.41,270.41,0,0,1,12.55-37A277.87,277.87,0,0,1,135.52,207Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.09,356.76V495.09H434.85V356.76Zm0,142.61v118.8c1.24.25,2.46.5,3.69.71,1.65.32,3.31.61,5,.86l1,.14c.66.11,1.33.2,2,.28,1.67.24,3.34.42,5,.58.78.08,1.59.14,2.38.21l1.93.14h0c1.05.08,2.09.14,3.13.18.64,0,1.28.05,1.93.07s1,0,1.52,0l1.89,0c.86,0,1.72,0,2.57,0h1.1c.86,0,1.72,0,2.57-.08h.05c.6,0,1.19,0,1.79-.07a4.38,4.38,0,0,0,.51,0c.5,0,1,0,1.48-.06a2.09,2.09,0,0,1,.34,0c1.11-.07,2.23-.16,3.36-.26s2.2-.22,3.33-.34l2.27-.28a199.13,199.13,0,0,0,27.45-5.84c20.23-5.64,40-13.53,60.22-19.3,26.12-7.45,55-11.12,80.24-2.05V499.37ZM434.85,202.74V18.58a278.53,278.53,0,0,0-70.42,8.25c-54.89,13.79-104.18,43.7-146.34,81.9v94H229V207H218.09V352.48H434.85V207H273.63v-4.28Zm278.48-62.21c-13.58-.48-27.08-4.77-39.3-11.42-23.34-12.69-42-32.31-62.84-48.85-43.3-34.47-97-55.28-152.09-60.44V202.74H768.51l.77-.81Zm28.19-5,29.89,32.81V126.9C761.35,128.17,752.59,131.12,741.52,135.49Zm29.89,512.14V499.37H707.67c-.16-.63-.34-1.27-.54-1.91.19.64.36,1.28.53,1.91H459.1V606.61c2.36,1.75,4.69,3.6,7,5.46h0q3.74,3.06,7.43,6.19l2.48,2.05c1.19,1,2.4,2,3.6,2.95q3.61,2.91,7.27,5.76,1.83,1.44,3.68,2.83a502.09,502.09,0,0,0,61.64,40.31c4.82,2.69,9.69,5.28,14.59,7.81q4.89,2.52,9.85,4.94,7.44,3.63,15,7s0,0,0,0a550.6,550.6,0,0,0,146,42.52q16.78,2.47,33.71,3.9V647.65l1,0ZM459.1,207V352.48H771.41V207Zm0,149.74V495.09H771.41V356.76ZM795.65,126.7V173l38.14-41.87Q814.83,128,795.65,126.7Zm0,230.06V495.09H1099.4V356.76Zm302.68,301.88,1.07-159.27H795.65V739.94a547.32,547.32,0,0,0,58.7-.71h0l.34,0q14-.9,27.87-2.56l.21,0A512.49,512.49,0,0,0,1026,698.41m132-318.93q-1.73-4-3.55-8c-2.26-5-4.64-9.86-7.1-14.71h-23.7V495.09h59.91C1183.51,455.91,1173.59,415.91,1158,379.48Zm-34.35,119.89v137c16.87-16.17,31.14-34.68,41.4-55.84,12.35-25.49,18-53.07,18.47-81.17Zm0-182.92v36h21.48A391.16,391.16,0,0,0,1123.65,316.45Zm-206-162.6c-1.58-.61-3.17-1.22-4.76-1.8a432.15,432.15,0,0,0-51.3-15.42l-58.38,64.06h0l-1.14,1.23.75.81h207.78A443.9,443.9,0,0,0,917.65,153.85ZM1016.7,207H799.91l-4.26,3.89V352.48H833a.05.05,0,0,0,0,0l0,0H1099.4v-68.6A432.49,432.49,0,0,0,1016.7,207Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.85,280.39v72.09H92.69c0-.42.06-.85.1-1.27.09-1.15.18-2.29.28-3.44.1-1.34.23-2.68.36-4s.26-2.92.42-4.37.29-2.92.45-4.37.32-2.9.5-4.34.34-2.9.54-4.34c.15-1.19.3-2.39.47-3.59.23-1.69.47-3.38.72-5.06,0-.26.08-.51.12-.76a348.93,348.93,0,0,1,7.44-36.52Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.37,356.76H193.85V495.09H99.79c-.24,1.43-.48,2.85-.75,4.28h94.81V610.91c-.16,0-.32-.12-.47-.18q-4-1.59-8-3.37c-.57-.26-1.13-.53-1.71-.78q-4-1.89-8-4c-.93-.49-1.86-1-2.77-1.52A166.43,166.43,0,0,1,133,570c-.35-.33-.67-.69-1-1-1.62-1.76-3.21-3.54-4.75-5.36-.58-.67-1.14-1.35-1.71-2-1.82-2.22-3.58-4.52-5.28-6.83-.26-.35-.5-.69-.75-1a147.72,147.72,0,0,1-17.2-31.1c-.14-.33-.27-.69-.4-1-1.38-3.5-2.63-7.05-3.71-10.67-.46-1.51-.91-3-1.29-4.57-.14-.45-.25-.91-.37-1.36-5.62-22.15-6.27-45.17-6.27-68.08q0-4,0-8Q90.39,415,90.6,401q.08-3.6.15-7.23.21-9.19.6-18.42c.06-1.7.14-3.41.23-5.1q.06-1.47.15-2.94Q92,362,92.37,356.76Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "278.44 209.28 278.44 333.92 202.13 333.92 202.13 209.28 213.01 209.28 213.01 167.08 257.67 167.08 257.67 209.28 278.44 209.28",
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 202.13,
    y: 338.19,
    width: 76.3,
    height: 138.33,
    fill: "#00b0ff",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.09,499.37h76.3v115a197.64,197.64,0,0,1-27.45,5.83c-.76.11-1.51.2-2.27.28-1.12.13-2.23.25-3.34.35l-3.35.27-.34,0-1.48.08-.51,0c-.6,0-1.19.07-1.79.08h-.05c-.86,0-1.71.06-2.57.08h-1.1c-.85,0-1.7,0-2.57,0l-1.88,0-1.53,0c-.65,0-1.29,0-1.94-.08q-1.54-.06-3.12-.18h0l-1.93-.14c-.8-.06-1.6-.14-2.39-.22q-2.52-.22-5-.57l-2-.28-1-.14c-1.67-.25-3.33-.53-5-.85-1.24-.22-2.46-.47-3.69-.73Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 692.53,
    y: 194.56,
    width: 62.92,
    height: 139.35,
    fill: "#00b0ff",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "755.46 338.19 755.46 476.53 443.15 476.53 443.15 416.86 609.5 416.86 609.5 452.06 692.53 452.06 692.53 338.19 755.46 338.19",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M772.4,647.7c-.33,0-.66,0-1-.06v90.75Q754.49,737,737.7,734.5A551.33,551.33,0,0,1,591.64,692q-20.13-9.08-39.44-19.79a503.91,503.91,0,0,1-61.63-40.31q-7.38-5.64-14.54-11.53c-3.31-2.74-6.59-5.54-9.93-8.25-2.3-1.87-4.63-3.72-7-5.48V499.37H707.66c-.18-.64-.34-1.27-.52-1.91.19.64.37,1.27.53,1.91h63.74V647.63C771.74,647.64,772.07,647.67,772.4,647.7Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M935.51,202.74h-41V190h18.37V152.05q2.39.88,4.76,1.8V190h17.86Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.3,352.48H833a.13.13,0,0,0,.06,0l-.09,0H795.65V213.13h10.58v103h48.34v-61h39.95V207h41v48.16h39.93v61h58.86Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M795.65,356.76V495.09h238.66V356.76Zm303.41,301.15.34-109.5h-65.09v-49H795.65V739.94a547.32,547.32,0,0,0,58.7-.71h0l.34,0q14-.9,27.87-2.56l.21,0A512.49,512.49,0,0,0,1026,698.41",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.85,499.37h55.67c-.48,28.09-6.12,55.68-18.47,81.16-10.26,21.17-24.53,39.68-41.4,55.85v-88h4.2Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.56,495.09h-55.71V379.48H1158C1173.59,415.91,1183.51,455.91,1183.56,495.09Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 721.75,
    y: 233.3,
    width: 33.71,
    height: 43.69,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 721.75,
    y: 323.86,
    width: 33.71,
    height: 10.06,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 721.75,
    y: 338.19,
    width: 33.71,
    height: 29.35,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 721.75,
    y: 414.42,
    width: 33.71,
    height: 43.69,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 721.75,
    y: 504.98,
    width: 33.71,
    height: 43.69,
    fill: "#00b0ff",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M771.41,647.63c.33,0,.66,0,1,.07-.33,0-.66,0-1-.06v10.15H737.7V614.1h33.71Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M771.41,704.65v33.74Q754.49,737,737.7,734.5V704.65Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 443.15,
    y: 473.32,
    width: 144.47,
    height: 3.21,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 443.15,
    y: 480.8,
    width: 144.47,
    height: 12.3,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 443.15,
    y: 533.42,
    width: 144.47,
    height: 19.78,
    fill: "#00b0ff",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M603.57,612.08v19.78h-113q-7.38-5.62-14.54-11.54c-3.32-2.73-6.6-5.53-9.93-8.24Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M603.57,672.17V692H591.64q-20.13-9.08-39.44-19.79Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 838.4,
    y: 351.6,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 222.62,
    y: 219.09,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 222.62,
    y: 285.15,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 222.62,
    y: 351.21,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 222.62,
    y: 417.26,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 222.62,
    y: 483.32,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 222.62,
    y: 549.38,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 946.97,
    y: 351.6,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 838.4,
    y: 421.75,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 946.97,
    y: 421.75,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 838.4,
    y: 491.89,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 946.97,
    y: 491.89,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 838.4,
    y: 562.04,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 946.97,
    y: 562.04,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 838.4,
    y: 632.19,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 946.97,
    y: 632.19,
    width: 28.44,
    height: 28.44,
    fill: "#00b0ff",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "838.4 720.67 838.4 702.33 866.83 702.33 866.83 718.06 838.4 720.67",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.53,316.91v16.27h97.32V316.91Zm9.69,15.25h-8V317.94h8Zm9.69,0h-8V317.94h8Zm9.67,0h-8V317.94h8Zm9.69,0h-8V317.94h8Zm9.68,0h-8V317.94h8Zm9.69,0h-8V317.94h8Zm9.69,0h-8V317.94h8Zm9.68,0h-8V317.94h8Zm9.68,0h-8V317.94h8Zm9.69,0h-8V317.94h8Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.53,364.27v16.27h97.32V364.27Zm9.69,15.25h-8V365.3h8Zm9.69,0h-8V365.3h8Zm9.67,0h-8V365.3h8Zm9.69,0h-8V365.3h8Zm9.68,0h-8V365.3h8Zm9.69,0h-8V365.3h8Zm9.69,0h-8V365.3h8Zm9.68,0h-8V365.3h8Zm9.68,0h-8V365.3h8Zm9.69,0h-8V365.3h8Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.53,411.64V427.9h97.32V411.64Zm9.69,15.23h-8V412.65h8Zm9.69,0h-8V412.65h8Zm9.67,0h-8V412.65h8Zm9.69,0h-8V412.65h8Zm9.68,0h-8V412.65h8Zm9.69,0h-8V412.65h8Zm9.69,0h-8V412.65h8Zm9.68,0h-8V412.65h8Zm9.68,0h-8V412.65h8Zm9.69,0h-8V412.65h8Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.53,459v16.26h97.32V459Zm9.69,15.24h-8V460h8Zm9.69,0h-8V460h8Zm9.67,0h-8V460h8Zm9.69,0h-8V460h8Zm9.68,0h-8V460h8Zm9.69,0h-8V460h8Zm9.69,0h-8V460h8Zm9.68,0h-8V460h8Zm9.68,0h-8V460h8Zm9.69,0h-8V460h8Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97,506.34c.38,1.54.83,3.06,1.29,4.57v-3.54h8v14.21H102c.12.34.25.69.39,1h91.5V506.34Zm19,15.24h-8V507.37h8Zm9.67,0h-8V507.37h8Zm9.69,0h-8V507.37h8Zm9.68,0h-8V507.37h8Zm9.69,0h-8V507.37h8Zm9.69,0h-8V507.37h8Zm9.68,0h-8V507.37h8Zm9.68,0h-8V507.37h8Zm9.69,0h-8V507.37h8Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119.54,553.7c.26.32.5.68.75,1h5.29v6.83l1.71,2v-8.87h8V569H132c.32.33.63.68,1,1h60.83V553.7ZM145,569h-8V554.72h8Zm9.69,0h-8V554.72h8Zm9.69,0h-8V554.72h8Zm9.68,0h-8V554.72h8Zm9.68,0h-8V554.72h8Zm9.69,0h-8V554.72h8Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M172.93,601.06c.92.52,1.85,1,2.78,1.51v-.5h8v4.51c.58.25,1.13.52,1.7.78v-5.29h8v8.66a3.26,3.26,0,0,0,.47.17v-9.84Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M833,352.48h0a.05.05,0,0,0,0,0Zm-61.6,295.15v0l1,0ZM707.13,497.46c.19.64.36,1.28.53,1.91h0C707.51,498.74,707.33,498.1,707.13,497.46ZM833,352.48h0a.05.05,0,0,0,0,0ZM229,202.74V207h44.67v-4.28ZM771.41,647.63v0l1,0ZM707.13,497.46c.19.64.36,1.28.53,1.91h0C707.51,498.74,707.33,498.1,707.13,497.46ZM833,352.48h0a.05.05,0,0,0,0,0Zm-61.6,295.15v0l1,0ZM707.13,497.46c.19.64.36,1.28.53,1.91h0C707.51,498.74,707.33,498.1,707.13,497.46Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 879.43,
    cy: 847.22,
    rx: 97.44,
    ry: 15.65,
    fill: "#00b0ff",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.97,
    cy: 831.57,
    rx: 97.44,
    ry: 15.65,
    fill: "#00b0ff",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M568.1,436.31a.53.53,0,0,0-.15-.26c-1.49-1.47-20.49-28.34-20.49-28.34s-1-3-2.62-6.9a6.86,6.86,0,0,0,1.15-2.25,7.72,7.72,0,0,0,.19-1.05c0-.11.08-.2.11-.31a7.59,7.59,0,0,0-.1-4.12,7.12,7.12,0,0,1-.41,1,16.72,16.72,0,0,0-1.5-3.34c-2.52-4.34-6.12-8-8.77-12.23A33.09,33.09,0,0,1,531,356.55c0,.39,0,.79,0,1.18a34.24,34.24,0,0,1,.6-4.5,31.22,31.22,0,0,1,1.67-4.94c2.38-5.45,6.23-10.2,8.57-15.67a29.7,29.7,0,0,0,1.78-5.73,32.1,32.1,0,0,0,.89-10.05c0,.8-.13,1.6-.25,2.39a32.55,32.55,0,0,0-9.19-21.67c-8.17-8.21-19.9-11.4-31.12-13.08a28.51,28.51,0,0,1-13.1-5c-4.31-2.79-9.88-3.46-14.92-2.85a24.61,24.61,0,0,0-15.19,7.51c-5.33,5.86-7.64,14.16-13.86,19.1-3.77,3-8.55,4.4-12.94,6.44s-8.54,5-9.95,9.38c0,0,0-.06,0-.09l0,.25-.06.16c-1.46,5.18,1.36,10.45,2.83,15.62,1.53,5.35,1.63,11,1.71,16.53.11,6.76.21,13.53.1,20.3-.05,2.66-.14,5.35-.34,8a41.92,41.92,0,0,0-6.87,2.76c-2.24,1.46-10.62,10.51-10.62,10.51l-16.39,62.62.22.25-.22.85.83-.19c2.32,2.5,9.25,9.62,16.73,14.06l.7,12.28s.84,12.32,12.17,17.41c.26,4.27,1.07,21.61-2.68,28.48a32,32,0,0,0-3.54,16.28s1.31,10.42-.18,15.9a26,26,0,0,0-.19,11.16h0s0,1.21,0,3.29c0,11.09.13,46.63,0,50.65-.19,4.75,0,75,0,75s-.93,35.11-3.91,44.62-2.23,41-2.23,41-1.87,37.51,4.74,44.91c0,.33-.06.67-.07,1,0,.15,0,.32,0,.47-.08,2.85.47,5.88,2.92,6.81,5,1.92,11.61,7.68,12.86,9.33s8.52,5.76,18,4.66a135.5,135.5,0,0,1,17.89-.82h0s3.74-.68,2.53-5.33h0s0,0,0,0c-.78-2.9-3.7-7.36-5.78-10.29.38.1.75.18,1.1.25l.36.07.28,0a3.8,3.8,0,0,0,.46,0l.2,0a3.43,3.43,0,0,0,.56,0h0c2.51-.24,11.87,4.12,13.54,7s7.56,5.07,12,5.62c2.64.32,9.3-.22,14.89-.94a54.83,54.83,0,0,0,8.34-1.52c1.32-.5,1.6-2.1,1.22-3.9h0a10.15,10.15,0,0,0-3.46-5.84c-1.62-1.15-3.76-4.18-5.34-6.66l-.42-.67c2.79-2.66,7.83-11.36,9.36-13.16,1.86-2.19-3-82.28-3-82.28V695.32l7.45-38,5.21-20.11,4.47-30.36s7.82-35.46,5.41-38.94h0c0-.07-2-36.58-4.1-45.35-.91-3.91-.68-12.71-.14-21.27a4.2,4.2,0,0,0,1-4.38,9.1,9.1,0,0,0-.58-1.49c0-.15,0-.31,0-.46a68.86,68.86,0,0,1,13.47-4.58c7.45-1.46,5.59-5.3,5.59-5.3s1.68-3.29,2.79-5.3.19-19.75,0-21.21c-.07-.59-.53-3.85-1.06-7.55,2.39-1.7,5.5-3.81,8.89-5.81C570.08,441.39,568.63,437.36,568.1,436.31ZM470.9,689.84s-5.59,14.26-3.35,17.91-.37,17.2-.37,17.2l-1.87,20.11s-5.21,37.3-3.35,46.07c1.46,6.88,2,27.43,2.17,36h0a2.53,2.53,0,0,0-.37.18l-.25.13c.86-3.37.5-10.19-3.77-23.91l-.36-56.67s-.66-65.46,4.51-72.78,7-19.75,7-19.75-1.12,17.93-1.85,22.68S470.9,689.84,470.9,689.84ZM460.49,830.7c-.05.12-.11.24-.15.35l-.28-.36A2.94,2.94,0,0,0,460.49,830.7Z",
    transform: "translate(-15.95 -18.56)",
    fill: "url(#cb66075b-2ebe-455c-893b-1def13a8d59c)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M517.5,853.16c-2.89,1.11-18.56,3-22.94,2.47s-10.18-2.75-11.83-5.65-10.9-7.28-13.38-7a9,9,0,0,1-3-.42,36.93,36.93,0,0,1-5-1.92,9.28,9.28,0,0,1,.11-3.8,6.09,6.09,0,0,1,.22-.74,6.61,6.61,0,0,1,3.36-3.74l.36-.17a10.17,10.17,0,0,1,2.16-.66c7.86-1.51,40.29,1.52,40.29,1.52s.91,1.63,2.16,3.65c1.56,2.5,3.68,5.55,5.28,6.7a10.25,10.25,0,0,1,3.41,5.88C519.08,851.05,518.8,852.67,517.5,853.16Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M517.5,853.16c-2.89,1.11-18.55,3-22.93,2.47s-10.18-2.76-11.84-5.65-10.89-7.28-13.37-7-8-2.34-8-2.34-.86-4,1.64-6.73l5,3.55s13.38,4.15,15.86,8,7,6,13.53,6.39c4.88.32,16.09-1.58,21.34-2.53C519.08,851.05,518.81,852.67,517.5,853.16Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M469.63,858.26a133.13,133.13,0,0,0-17.66.83c-9.39,1.1-16.56-3-17.81-4.69S426.44,847,421.47,845c-2.43-.94-3-4-2.89-6.86,0-.15,0-.32,0-.47a28,28,0,0,1,.8-5.37l38.91-.83,3.37,4.57.52.7,2.05,2.79s.93,1.22,2.15,3c2.06,3,4.94,7.43,5.71,10.36v0C473.32,857.58,469.63,858.26,469.63,858.26Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M469.63,858.26a133.13,133.13,0,0,0-17.66.83c-9.38,1.1-16.56-3-17.8-4.69s-7.73-7.45-12.7-9.38c-2.43-.94-3-4-2.89-6.86,2.78.65,8.62,2.31,10.91,5.2,3,3.86,8.37,10.35,16,10.76,6.16.33,21.16-.77,26.66-1.21C473.33,857.58,469.63,858.26,469.63,858.26Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M465,832.32c-.45,3.34-1.84,4.24-2.84,4.44a1.93,1.93,0,0,1-.74,0,2.46,2.46,0,0,1-.39-.06s-34.94,7.72-42,1.47a4.89,4.89,0,0,1-.5-.52,28,28,0,0,1,.8-5.37l38.91-.83,3.37,4.57a6.61,6.61,0,0,1,3.36-3.74Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M510,836.66c-.78.86-1.43,1.35-1.84,1.18-1.84-.74-16.92-3.31-21.71-1.1s-21,.36-21,.36,0-1.92-.09-5a10.17,10.17,0,0,1,2.16-.66c7.86-1.51,40.29,1.52,40.29,1.52S508.76,834.64,510,836.66Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M532.82,610.46,528.4,641l-5.14,20.24L515.9,699.5V740s4.78,80.58,2.94,82.78-8.83,14.73-10.67,14-16.92-3.31-21.71-1.11-21,.37-21,.37-.37-31.27-2.21-40.1,3.31-46.36,3.31-46.36l1.84-20.23s2.58-13.62.37-17.3,3.31-18,3.31-18-2.57-8.11-1.83-12.89,1.83-22.81,1.83-22.81-1.83,12.52-6.94,19.87-4.46,73.22-4.46,73.22l.36,57c9.21,30.18,0,27.23,0,27.23s-34.94,7.73-42,1.47S414,791.48,414,791.48s-.73-31.64,2.21-41.2,3.87-44.89,3.87-44.89-.19-70.65,0-75.42c.14-4,0-39.81,0-51,0-2.08,0-3.31,0-3.31l4.22-10.48,50-6.26h23.92s36,8.46,39.72,12.11a.83.83,0,0,1,.2.22C540.55,574.78,532.82,610.46,532.82,610.46Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M472.11,770.88s11,26.49,16.19,28.33S472.11,770.88,472.11,770.88Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M476.18,809.88s37.14,1.84,36.77,5.89S476.18,809.88,476.18,809.88Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M426.49,799.29c1.47,1.39,28.33,4,26.12,6.54s-23.91,7.48-23.91,7.48Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M422.08,753.59c0,1.1,5.52,35.32,7,36.79s13.61,2.94,13.61,2.94Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M462.13,285.85c-5.27,5.89-7.55,14.24-13.69,19.22-3.73,3-8.45,4.43-12.79,6.47s-8.64,5.15-9.93,9.77c-1.44,5.2,1.34,10.51,2.8,15.71,1.51,5.38,1.6,11,1.69,16.63.1,6.81.21,13.62.09,20.43-.18,10.61-1.06,21.71-6.69,30.7,20.33,6.47,41.95,7.35,63.27,8.18a63.84,63.84,0,0,0,12.29-.31A105.49,105.49,0,0,0,509.64,410a80.28,80.28,0,0,1,20.86-2.67c3.07,0,6.2.19,9.16-.61s5.81-2.85,6.61-5.81c.71-2.66-.33-5.49-1.69-7.88-2.48-4.36-6-8-8.66-12.3a33.8,33.8,0,0,1-2.17-30.39c2.36-5.49,6.16-10.27,8.48-15.77a33.26,33.26,0,0,0-6.7-35.28c-8.07-8.26-19.65-11.46-30.73-13.16a27.91,27.91,0,0,1-12.94-5c-4.25-2.8-9.76-3.48-14.74-2.86A24.06,24.06,0,0,0,462.13,285.85Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#3f3d56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.06,344.57a33.27,33.27,0,0,0-2.55,15.27A32.7,32.7,0,0,1,534.06,349c2.35-5.49,6.15-10.27,8.47-15.77a31.91,31.91,0,0,0,2.33-14.52,31.1,31.1,0,0,1-2.33,10.1C540.21,334.31,536.41,339.08,534.06,344.57Z",
    transform: "translate(-15.95 -18.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.51,352.29c.06,3.92.12,7.85.13,11.77,0-5.4-.05-10.79-.13-16.18-.08-5.59-.18-11.25-1.69-16.64-1-3.42-2.48-6.89-3-10.34-.89,4.9,1.64,9.87,3,14.76C430.33,341,430.43,346.7,430.51,352.29Z",
    transform: "translate(-15.95 -18.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540,401c-3,.81-6.08.63-9.15.61A80.22,80.22,0,0,0,510,404.23a106.2,106.2,0,0,1-10.47,2.64,63.17,63.17,0,0,1-12.3.32c-20.6-.81-41.49-1.68-61.22-7.57a33.94,33.94,0,0,1-2,3.8c20.33,6.46,41.95,7.35,63.26,8.18a63.17,63.17,0,0,0,12.3-.32A103.41,103.41,0,0,0,510,408.65,80.22,80.22,0,0,1,530.81,406c3.07,0,6.19.19,9.15-.62s5.81-2.84,6.61-5.8a7.94,7.94,0,0,0-.1-4.16C545.58,398.22,542.83,400.17,540,401Z",
    transform: "translate(-15.95 -18.56)"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M510.38,389.15c-.74,1.66-3.86,16-4.6,17.47s-4.78,25-5.15,26.32S474,427.42,474,427.42l-15.81-13.25L441.94,398s-.48-14.59,11.49-19.27a18.27,18.27,0,0,1,2.5-.78c14.52-3.49,13.06-47.64,13.06-47.64l29.8,12.87s-5.52,25.76-5.33,30.73c.05,1.67,1.36,2.71,3.07,3.34a24.27,24.27,0,0,0,8.14.88S511.12,387.5,510.38,389.15Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fbbebe"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M563.73,437.53l4.23,1.11s3.13,4.76-4.23,9.19a127.48,127.48,0,0,0-13.43,9.39l-21.75,6.62-4.19-13.15,20.24-15.36Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M563.73,437.53l4.23,1.11s3.13,4.76-4.23,9.19a127.48,127.48,0,0,0-13.43,9.39l-21.75,6.62-4.19-13.15,20.24-15.36Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M405,450.23l-8.46,8.28s15.26,17.66,27,18.76,19.31-13.43,19.31-13.43l-10.16-16Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M405,450.23l-8.46,8.28s15.26,17.66,27,18.76,19.31-13.43,19.31-13.43l-10.16-16Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 469.41,
    cy: 311.17,
    r: 29.43,
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 469.41,
    cy: 308.96,
    r: 29.43,
    fill: "#fbbebe"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M538.16,574.59A95,95,0,0,0,518.47,579c-11,3.66-97.2.06-98.4,0,0-2.08,0-3.31,0-3.31l4.22-10.48,50-6.26h23.92s36,8.46,39.72,12.11C538.08,573.26,538.16,574.59,538.16,574.59Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M510.38,389.15c-.74,1.66-3.86,16-4.6,17.47s-4.78,25-5.15,26.32S474,427.42,474,427.42l-15.81-13.25L441.94,398s-.48-14.59,11.49-19.27l29.72,34.17,13.38-35.65a24.27,24.27,0,0,0,8.14.88S511.12,387.5,510.38,389.15Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M483.15,414l-30.42-35a12.75,12.75,0,0,0-12.07-.89c-6.81,2.95-15.27,5.34-17.48,6.81s-10.49,10.57-10.49,10.57L437.35,460l-10.86,42.49s1.66,21.71-2.57,29.62a32.51,32.51,0,0,0-3.5,16.37s1.29,10.49-.18,16a26.65,26.65,0,0,0-.19,11.22s87.39,3.68,98.42,0a94.18,94.18,0,0,1,19.69-4.41s-2-36.8-4-45.63,1.66-42.49,1.66-42.49l-2.39-36.06,14.34-37S540,386.39,531.9,384c0,0-14.71-3.5-17.84-5.15s-12.33-3.13-12.33-3.13l-4.83,1.62Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 454.92,
    y: 443.61,
    width: 70.04,
    height: 107.18,
    rx: 2.94,
    ry: 2.94,
    transform: "translate(18.92 -50.67) rotate(3.89)",
    opacity: 0.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 457.13,
    y: 441.41,
    width: 70.04,
    height: 107.18,
    rx: 2.94,
    ry: 2.94,
    transform: "translate(18.77 -50.82) rotate(3.89)",
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 461.6,
    y: 449.46,
    width: 61.02,
    height: 92.22,
    transform: "translate(18.81 -50.82) rotate(3.89)",
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 469.9,
    y: 471.21,
    width: 49.73,
    height: 13.86,
    transform: "matrix(1, 0.07, -0.07, 1, 17.63, -51.04)",
    opacity: 0.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 510.27,
    y: 529.92,
    width: 7.91,
    height: 7.24,
    transform: "translate(21.44 -52.23) rotate(3.89)",
    opacity: 0.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 469.94,
    y: 511.38,
    width: 40.49,
    height: 7.24,
    transform: "translate(20.13 -50.64) rotate(3.89)",
    opacity: 0.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 475.65,
    y: 446.75,
    width: 42.16,
    height: 11.13,
    transform: "translate(15.89 -51.23) rotate(3.89)",
    fill: "#3f3d56"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 475.65,
    y: 446.75,
    width: 42.16,
    height: 11.13,
    transform: "translate(15.89 -51.23) rotate(3.89)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M486.83,572.56s-.37,54.46-14.72,85.73c0,0,17.3-41.21,17.3-42.86s9.56-18.95,7-24.1S486.83,572.56,486.83,572.56Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M487.61,320.16a20.47,20.47,0,0,1,3.33-13.71A16.89,16.89,0,0,0,504,324.25a2.21,2.21,0,0,1-.63-2.42c2.05,2.32,3.62,5.07,5.94,7.11s5.8,3.26,8.53,1.81c3.71-2,3.75-7.27,2.79-11.37a53.4,53.4,0,0,0-12.29-23.47,16.26,16.26,0,0,0-12.9-6.56c-5.68-.44-11.58.06-16.67,2.61a44.3,44.3,0,0,0-8,5.59l-14,11.42a13.29,13.29,0,0,0-3.4,3.58,9.8,9.8,0,0,0-1.06,3.75,20.21,20.21,0,0,0,9.42,19.07,14.91,14.91,0,0,1,8.93-14,3.88,3.88,0,0,1,1.39,2.89L475,319a5.79,5.79,0,0,1,2-2.37c1.82-1,4.09.18,5.64,1.59s3.06,3.17,5.14,3.39l.08-7.83",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M487.61,319.06a20.48,20.48,0,0,1,3.33-13.72c-.9,8,5.13,16.26,13.07,17.8a2.19,2.19,0,0,1-.63-2.41c2.05,2.32,3.62,5.06,5.94,7.11s5.8,3.26,8.53,1.8c3.71-2,3.75-7.27,2.79-11.36a53.4,53.4,0,0,0-12.29-23.47,19.67,19.67,0,0,0-6.87-5.34,20,20,0,0,0-6-1.22c-5.68-.44-11.58.05-16.67,2.6a44.86,44.86,0,0,0-8,5.6l-14,11.42a13.15,13.15,0,0,0-3.4,3.58,9.75,9.75,0,0,0-1.06,3.75,20.2,20.2,0,0,0,9.42,19.06,14.93,14.93,0,0,1,8.93-14,3.91,3.91,0,0,1,1.39,2.89l2.94-5.24a5.73,5.73,0,0,1,2-2.37c1.82-1,4.09.18,5.64,1.59s3.06,3.16,5.14,3.39l.08-7.84",
    transform: "translate(-15.95 -18.56)",
    fill: "#3f3d56"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M501.55,504.69c-2.57-1.3-45.07,5.33-45.07,5.33s-7-2-23.92-4.78-18-19.32-18-19.32l-1.85-33.11,5.71-5,24.46,16s.38,8.09,0,9.55c-.24,1-.88,2.19-.82,3a1,1,0,0,0,.82.9c1.66.42,24.28,4.08,24.28,4.08s52.43-3.59,65.5,14.07a13.28,13.28,0,0,1,2.31,4.36C538.21,511.84,503.88,505.84,501.55,504.69Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fbbebe"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M535,499.84c-2,.89-3.24,1.53-3.24,1.53S513,500.82,502.46,497s-23.35-3.14-23.35-3.14S435.19,486.3,442,476.43a1,1,0,0,0,.82.9c1.66.42,24.28,4.08,24.28,4.08s52.43-3.59,65.5,14.07A13.28,13.28,0,0,1,535,499.84Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M553.24,441.58s2.58,18.21,2.76,19.69,1.11,19.31,0,21.34-2.76,5.33-2.76,5.33,1.84,3.86-5.52,5.34-16,5.88-16,5.88-18.77-.55-29.25-4.41-23.36-3.13-23.36-3.13-55.75-9.57-31.83-21.25,40.84,4.14,40.84,4.14l26.67-1.65s9.94-6.08,12.7-5.52a10.21,10.21,0,0,0,5.7-.92l.19-19.32Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fbbebe"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M418,396.88l-5.34-.28-16.18,63s17.47-4.42,25,0,21.34,5.33,21.34,5.33l-5.15-50.22Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M418,395.77l-5.34-.28-16.18,63s17.47-4.42,25,0,21.34,5.33,21.34,5.33l-5.15-50.22Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M540.37,409.57l7.35,1.66s18.77,27,20.24,28.51-7,7-10.49,7-20.6,2-25.57,6.62S529,434.73,529,434.2,535.17,419,535.17,419Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M540.37,408.47l7.35,1.65s18.77,27.05,20.24,28.52-7,7-10.49,7-20.6,2-25.57,6.62S529,433.63,529,433.1s6.21-15.25,6.21-15.25Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.89,305.43a14.75,14.75,0,0,1,.05-2.3,20.47,20.47,0,0,0-3.08,7.55l0,2.32s0-.05,0-.08l0,.55c0,1.62,0,3.25-.05,4.87l-.14,0,0,.75c0-.26,0-.51-.05-.77-2-.32-3.43-2-4.92-3.34s-3.82-2.62-5.64-1.59a5.73,5.73,0,0,0-2,2.37L472.09,321a3.87,3.87,0,0,0-1.39-2.88,14.91,14.91,0,0,0-8.93,14,20.32,20.32,0,0,1-9.49-15.93,20.22,20.22,0,0,0,9.49,18.13,14.93,14.93,0,0,1,8.93-14,3.91,3.91,0,0,1,1.39,2.89l2.94-5.24a5.73,5.73,0,0,1,2-2.37c1.82-1,4.09.18,5.64,1.59s3.06,3.16,5.14,3.39q0-3.84.08-7.66A20.37,20.37,0,0,1,490.89,305.43Z",
    transform: "translate(-15.95 -18.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.51,315.5c.05-.68.13-1.36.23-2l.11-2.76A20.24,20.24,0,0,0,487.51,315.5Z",
    transform: "translate(-15.95 -18.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.85,327.43c-2.73,1.46-6.21.24-8.53-1.8s-3.89-4.79-5.94-7.11a2.21,2.21,0,0,0,.63,2.42c-.2,0-.39-.1-.58-.15,2,2.3,3.59,5,5.89,7s5.8,3.26,8.53,1.8,3.51-4.88,3.27-8.21C520.94,324,520,326.27,517.85,327.43Z",
    transform: "translate(-15.95 -18.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.37,320.77a17,17,0,0,1-12.46-14.86c-.57,7.85,5.35,15.72,13.1,17.23A2.2,2.2,0,0,1,503.37,320.77Z",
    transform: "translate(-15.95 -18.56)"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M983.61,484.21s-3.94-.55-3.94-6.28-2.82-16.46-2.82-16.46h0s-2.44-18.67-5.81-21.63-7.7-20.34-7.7-20.34-.74-9.43-2.25-11.46-3.55-7-6.56-14.09S939,382,939,382s-22.69-13.16-29.12-17.45h0a9.94,9.94,0,0,1-1.64-1.24c-1.12-1.46-6-1.49-6-1.49-.51-3.23-1-6.93-1.16-10.28,0-.36,0-.72,0-1.08a34.6,34.6,0,0,0,15.21-18.82c.12-.38.22-.77.33-1.16a3.25,3.25,0,0,0,2-1.76c.57-1.29.59-2.79,1.31-4,.84-1.42,2.44-2.18,3.7-3.24,3.18-2.71,4-7.26,3.85-11.39-.1-3.36-.64-6.74-.43-10.07,0-.28,0-.56.06-.84.06-.49.13-1,.22-1.48.49-2.48,1.56-4.82,2.16-7.28s.66-5.23-.74-7.35c-2.05-3.11-6.32-3.73-10.07-4-4.25-.36-8,.1-10.77-3.43a37.7,37.7,0,0,0-4.28-5.16c-.56-.52-6-3.85-6-4.06a24.31,24.31,0,0,0-17-1.31c-2.83.82-5.48,2.16-8.35,2.83-6.16,1.46-13.26-.12-18.5,3.41-2.92,2-4.67,5.19-6.31,8.28q-2,3.82-4.06,7.65c-2.22,4.19-4.46,8.45-5.39,13.09a22.19,22.19,0,0,0-.37,3.07v0c0,.37,0,.74,0,1.11,0,.16,0,.32,0,.48,0,.34,0,.68.06,1s0,.41.07.62.09.68.15,1,.18.89.3,1.32c0,.19.12.37.18.56s.22.67.35,1,.14.35.22.52c.15.35.33.69.51,1,.08.13.14.26.22.39a11.34,11.34,0,0,0,.92,1.34c2.13,2.67,5.29,4.37,7.62,6.87,0,.1,0,.2,0,.3,0,.27,0,.54,0,.82a34.23,34.23,0,0,0,15.68,27.9c0,.38.05.77.07,1.16a57.09,57.09,0,0,1-.11,8.9,4.22,4.22,0,0,0-3.32-1.48,4.76,4.76,0,0,0-1.28.11l-.09-.07h0v.09c-2.2.54-4.91,2.83-7.5,9.34,0,0-7.88,8.88-13.88,8.51s-21.19,9.25-21.19,9.25-14.82,9.61-18,19.41a135.69,135.69,0,0,1-6.39,16.28l-18.37,37.72h0l-3.37,30s1.87,13.31,1.5,15.35,7.69,20.34,7.69,20.34,26.63,46.78,37.51,49.18l.78-.54a6.81,6.81,0,0,0,1.47.54l2.24-1.57a23.41,23.41,0,0,1-.18,5.27c-1.49,4.63.57,34.77,3.19,40.68s1.69,83.41,1.69,83.41l-.37,6.83s0,.22.09.6l-.09,1.62.27.14a19.33,19.33,0,0,1-.27,6.52c-.94,3-1.32,11.47-1.32,11.47s-7.5,47.88-3.94,57.5,6.57,20.16,6.57,20.16,3.75,12,.18,14-13.68,5.55-11.62,10.54c1.9,4.62,9.11,17,10.18,18.81l-.09,1-1.47,15.93a20,20,0,0,0,1.69,6.08c1.61,3.48,4.73,7.07,10.69,6.68,1-.07,2.15-.18,3.28-.33,10.89-1.47,24.29-6.33,24.29-6.33a9.58,9.58,0,0,1-1.89-1.57h0a5.49,5.49,0,0,1-1.67-4c.16-2.91-5.27-16.72-6.63-20.13l-.31-.76s12.38-12.95,10.32-24.41c0,0-13.7-8-9.19-12.4s12.57-17,12.57-17,.37-47.15,0-54.18a58.4,58.4,0,0,1,.69-14.64c.15-.72.33-1.43.52-2.14a127.74,127.74,0,0,0,18.86,1.43q3.46,0,7-.14,0,1,.09,2.16c.52,11.68,1.49,32.17,2.28,39.78,1.12,10.9,7.31,40.31,7.31,40.31s-11.81,7.57,2.06,26.26c0,0,0,6.76-.92,7.75h0a84.62,84.62,0,0,0-2.37,9.77c-.58,3.51-.82,7.08.12,8.92,2.25,4.42,15.75,4.06,15.75,4.06h0a2.13,2.13,0,0,1,.33-.05,19.27,19.27,0,0,1,14.29,4.3c5.13,4.12,24.59,2.32,35.14,1,4.13-.53,6.89-1,6.89-1a4.05,4.05,0,0,0,.14-1.44h0c-.11-2.59-2.14-8.27-15.9-13.34,0,0-12.94-8.7-12.76-16.28h-.29l-1.49,0C946.34,835,947,835,947,835s-5.07-18.49-3-20-4.13-22-4.13-22-3.55-34.4-3.75-36.8a21.14,21.14,0,0,1,.94-6.1l-.94-18.87s-.18-6.27,0-8.31a39.08,39.08,0,0,0-.42-5.29c-.09-.7-.18-1.43-.28-2.15,4.85-1.23,8-2.36,8-2.36l-.56-65.65c4.12-8,4.88-25.56,4.86-38,0-8-.36-13.92-.36-13.92l5.63-9.19s1.3-11-.76-13.41c-.91-1.09-.5-2.22.25-3.15a10.46,10.46,0,0,1,1.25-.88,1.57,1.57,0,0,1-.13-.22,9.94,9.94,0,0,1,1.25-.89s-2-3.1-.21-4.41c1.68,1.14,3.18,2.05,4.32,2.7-.08.73-.16,1.15-.16,1.15l.48-1c1.1.62,1.77,1,1.77,1s8.82-17.57,8.63-20.15,6-13.5,6-13.5.75-5.74,4.13-8.14,2.62-19.79,2.62-19.79.94-9.06,3.19-12.75S983.61,484.21,983.61,484.21ZM814.85,476.5l.17,4.19c-1-1.61-1.72-2.76-1.72-2.76Z",
    transform: "translate(-15.95 -18.56)",
    fill: "url(#b7415561-023b-44da-badb-9b3453976a8a)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M961.57,559.65l-2.16,9.2S942.11,560,939,548.8s5.21-15.47,5.21-15.47l16.13,6.82Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M961.57,559.65l-2.16,9.2S942.11,560,939,548.8s5.21-15.47,5.21-15.47l16.13,6.82Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M864.48,872.76s-16,5.88-27,6.62c-5.84.39-8.91-3.19-10.49-6.64a20.3,20.3,0,0,1-1.66-6l1.45-15.85.76-8.43,23.37-6.08,3.31,10.13.31.76c1.32,3.39,6.66,17.13,6.5,20a5.49,5.49,0,0,0,1.63,4A9.29,9.29,0,0,0,864.48,872.76Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M973.72,864.7a4,4,0,0,1-.14,1.44s-34.22,5.7-41.22,0A18.53,18.53,0,0,0,918,861.91s-13.24.36-15.45-4c-.92-1.83-.68-5.38-.11-8.87a85.07,85.07,0,0,1,2.32-9.72l.53-.42,3.15-2.53,36.88-1.09h.28c-.18,7.54,12.51,16.19,12.51,16.19C971.62,856.47,973.61,862.12,973.72,864.7Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M973.73,864.7a4.12,4.12,0,0,1-.15,1.44s-34.22,5.7-41.21,0A18.53,18.53,0,0,0,918,861.91s-13.25.36-15.46-4c-.91-1.83-.68-5.38-.11-8.88,5.1.51,13.15,1.78,16.31,4.82,4.78,4.6,12.88,9.2,17.84,9.57C940.5,863.66,963.81,864.4,973.73,864.7Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M864.48,872.76s-16,5.88-27,6.62c-5.84.39-8.91-3.19-10.49-6.64,4.08,1.37,9.73,2.8,12.7,1.49,3.52-1.57,16-2.57,23-3A9.09,9.09,0,0,0,864.48,872.76Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M888.22,398.87c-13.2-5.13-30.18-22.08-25.94-30a17.93,17.93,0,0,0,1.65-6.36,58.05,58.05,0,0,0,.12-9,123.6,123.6,0,0,0-1.77-14.65s41.21.93,38.81,7c-.7,1.79-.82,4.88-.62,8.33s.69,7.38,1.21,10.69c.71,4.53,1.44,8,1.44,8s-2.53,3.53-4,3.72S907.16,406.22,888.22,398.87Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#cf6f80"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M854.49,847.22l-.31.34c-12.32-14.9-27.22,3.68-27.22,3.68l-.22-.4.76-8.43,23.37-6.08,3.31,10.13Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M945.62,836.33s-9-.18-13.8,4.06-28,.91-27,0a3.46,3.46,0,0,0,.52-1.53l3.15-2.53,36.88-1.09C945.51,835.94,945.62,836.33,945.62,836.33Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M869.82,719.32a28.05,28.05,0,0,0-1.52,5.13,58.71,58.71,0,0,0-.69,14.56c.37,7,0,53.91,0,53.91s-7.91,12.51-12.33,16.92,9,12.33,9,12.33c2,11.41-10.12,24.29-10.12,24.29-12.32-14.9-27.22,3.67-27.22,3.67s-8.1-14-10.12-19,7.91-8.45,11.4-10.49-.18-14-.18-14-2.94-10.49-6.44-20.06,3.86-57.2,3.86-57.2.38-8.47,1.29-11.42a19.34,19.34,0,0,0,.27-6.48c-.06-.73-.13-1.33-.18-1.75s-.09-.6-.09-.6l.14-.24,5-9.32S872.22,713.45,869.82,719.32Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M945.62,835.23s-9-.19-13.8,4-28,.92-27,0,.91-7.72.91-7.72c-13.61-18.59-2-26.13-2-26.13s-6.07-29.25-7.17-40.1c-.77-7.57-1.72-28-2.23-39.57-.22-5-.35-8.45-.35-8.45L905,715.07l1.43-.28,26.82-5.39s.74,5,1.24,9.09a39.94,39.94,0,0,1,.41,5.27c-.17,2,0,8.27,0,8.27l.92,18.76a21.64,21.64,0,0,0-.92,6.07c.19,2.4,3.68,36.61,3.68,36.61s6.07,20.42,4,21.89S945.62,835.23,945.62,835.23Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M901.09,345.89c-.7,1.79-.82,4.88-.62,8.33a34.25,34.25,0,0,1-36.42-.68,123.6,123.6,0,0,0-1.77-14.65S903.49,339.82,901.09,345.89Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M917,323.81a34.21,34.21,0,0,1-68.42.82c0-.28,0-.54,0-.82a34.22,34.22,0,0,1,68.44,0Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#cf6f80"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M888.22,398.87c-13.2-5.13-30.18-22.08-25.94-30a17.93,17.93,0,0,0,1.65-6.36L882,377.37l11.18,9.17,8.5-21.63c.71,4.53,1.44,8,1.44,8s-2.53,3.53-4,3.72S907.16,406.22,888.22,398.87Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "919 445.98 903.91 699.48 884.23 700.77 833.26 553.78 841.62 379.27 843.39 342.4 866.05 361.01 877.23 370.18 885.98 347.91 902.25 362.09 919 445.98",
    fill: "#00b0ff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M869.82,719.32a28.05,28.05,0,0,0-1.52,5.13A145,145,0,0,1,827,711.56l-.27-.14.09-1.61,0-.84,5-9.32S872.22,713.45,869.82,719.32Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M905.33,724.49a101.29,101.29,0,0,1-11.06,1.27c-.22-5-.35-8.45-.35-8.45L905,715.07Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M934.53,718.49c-7.11,1.85-18.1,3.93-27.92,2.63l-.14-6.33,26.82-5.39S934,714.36,934.53,718.49Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M906.43,722.28c-41,7-78.55-13.07-78.55-13.07l.36-6.8s.93-77.09-1.65-83S822,583.57,823.46,579s-5.33-73.57-5.33-73.57l-1.1-28-40.29-16.37,18-37.53A135.61,135.61,0,0,0,801,407.33c3.13-9.75,17.66-19.32,17.66-19.32s14.9-9.56,20.79-9.2,13.61-8.46,13.61-8.46c5.7-14.53,10.86-8,10.86-8,0,.7,0,0-.28,2.15-2,15.95,32.34,66.35,32.83,67.25h0l3.31,79.66,3.31,100.81Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M905.33,722.28c-41,7-78.56-13.07-78.56-13.07l.37-6.8s.92-77.09-1.66-83-4.59-35.87-3.12-40.48S817,505.39,817,505.39l-1.11-28-40.28-16.37,18-37.53a137.73,137.73,0,0,0,6.26-16.19C803,397.58,817.58,388,817.58,388s14.9-9.56,20.78-9.2S852,370.35,852,370.35c5.71-14.53,12-8,12-8,0,.7-.6,1-.28,2.15,4.4,15.47,31.24,66.35,31.73,67.25h0l3.31,79.66L902,612.27Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M894.28,434c-4.41-1.84-27.77-28.51-27.77-28.51v-6.07c-.85-2-5.91-.78-10,.62l1.76-36.87,2,1.66C864.64,380.29,893.8,433.11,894.28,434Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M895.39,431.8c-4.42-1.85-27.78-28.51-27.78-28.51v-6.08c-.85-2-5.9-.78-10,.62L859.34,361l2,1.65C865.75,378.09,894.9,430.9,895.39,431.8Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M827.88,564.8c.55,0,28.51-2.94,28.51-2.94s16.93,33.3,15.82,41.39-3.12,15.27-9.93,14-36.65,1-36.65,1Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M826.77,562.59c.56,0,28.52-2.94,28.52-2.94S872.21,593,871.11,601s-3.13,15.27-9.93,14-36.66,1-36.66,1Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M847.84,547s25.66,13.8,26.21,18-13.06-1.84-16-2.58a38.14,38.14,0,0,0-5.89-.92l-19.61.53Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#cf6f80"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.16,
    cy: 414.46,
    r: 2.7,
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.16,
    cy: 413.36,
    r: 2.7,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.13,
    cy: 531.34,
    r: 2.7,
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.13,
    cy: 530.23,
    r: 2.7,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 873.86,
    cy: 472.9,
    r: 2.7,
    opacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 873.86,
    cy: 471.8,
    r: 2.7,
    fill: "#3f3d56"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M952.05,560.94s1.84,2.76,0,4,.18,4.42.18,4.42-4.59,2.68-2.57,5.11.74,13.34.74,13.34L944.88,597s.33,5.89.35,13.85c0,12.42-.73,29.88-4.77,37.84L941,714s-19.33,7.07-35.51,4.91l-2.4-104.8s3.5-59.43,4.79-70.83a118.65,118.65,0,0,0,.92-17.85s-.55-17.84-2.4-26.11c0,0-2-35.88-2.2-45.81-.09-4.75.16-18.61.44-31.79.31-14.41.66-28,.66-28l-3.65-28.89s3.65-.36,4.75,1.1a10.53,10.53,0,0,0,1.6,1.23h0c6.31,4.26,28.57,17.36,28.57,17.36s12.32,4.9,15.27,11.92,5,12,6.43,14,2.21,11.4,2.21,11.4,4.24,17.3,7.55,20.23,5.69,21.53,5.69,21.53l-29.25,23s-2.57,38.26-3.12,39.74S952.05,560.94,952.05,560.94Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M953.16,560.94s1.83,2.76,0,4,.17,4.42.17,4.42-4.59,2.68-2.57,5.11.74,13.34.74,13.34L946,597s.33,5.89.36,13.85c0,12.42-.73,29.88-4.77,37.84l.55,65.31s-19.33,7.07-35.51,4.91l-2.39-104.8s3.49-59.43,4.79-70.83a117.56,117.56,0,0,0,.91-17.85s-.55-17.84-2.39-26.11c0,0-2-35.88-2.21-45.81-.09-4.75.16-18.61.44-31.79.31-14.41.66-28,.66-28l-4.82-29.28s4.82,0,5.93,1.49a9.49,9.49,0,0,0,1.6,1.23h0c6.3,4.26,28.56,17.36,28.56,17.36S950,389.42,953,396.44s5,12,6.43,14,2.21,11.4,2.21,11.4,4.24,17.3,7.55,20.23,5.7,21.53,5.7,21.53l-29.25,23s-2.57,38.26-3.13,39.74S953.16,560.94,953.16,560.94Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M918.13,402.21l2.65,7.7-13.91,14c.31-14.41.66-28,.66-28l-4.82-29.27s4.82,0,5.93,1.49a9.49,9.49,0,0,0,1.6,1.23h0l11.82,34.09Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M917,400l2.65,7.69-13.9,14c.3-14.41.66-28,.66-28l-4.83-29.28s4.83,0,5.93,1.49a10,10,0,0,0,1.6,1.23h0L921,401.25Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M917,323.81a34.11,34.11,0,0,1-1.68,10.61,1.42,1.42,0,0,1-1.08-.26c-.27-9-4.69-17.46-10.14-24.65a26.11,26.11,0,0,0-5.5-5.7,10.77,10.77,0,0,0-7.46-2.11c-3,.41-5.65,2.45-8.68,2.71-4,.33-7.58-2.44-11.55-2.57a11.32,11.32,0,0,0-8.49,3.94,23.16,23.16,0,0,0-4.55,8.43,49.38,49.38,0,0,0-2.54,14.56c-.05,2.8-.32,6.31-2.92,7.33a14.9,14.9,0,0,0-3.77-11.4l-.06-.07c0-.28,0-.54,0-.82a34.22,34.22,0,0,1,68.44,0Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M897,269.48a23.56,23.56,0,0,0-16.62-1.3c-2.77.82-5.38,2.15-8.19,2.82-6,1.45-13-.12-18.15,3.39-2.86,2-4.58,5.16-6.18,8.24l-4,7.61c-2.18,4.17-4.38,8.41-5.29,13s-.36,9.73,2.55,13.43c2.11,2.68,5.25,4.37,7.55,6.9A15,15,0,0,1,852.43,335c2.6-1,2.86-4.53,2.92-7.33a49.44,49.44,0,0,1,2.54-14.56,23.16,23.16,0,0,1,4.55-8.43,11.33,11.33,0,0,1,8.49-3.95c4,.14,7.59,2.91,11.55,2.57,3-.25,5.66-2.29,8.68-2.7a10.72,10.72,0,0,1,7.46,2.11,25.62,25.62,0,0,1,5.49,5.7c5.46,7.2,9.89,15.62,10.15,24.65,1.13.82,2.76-.26,3.32-1.54s.58-2.78,1.29-4c.82-1.41,2.39-2.17,3.62-3.23,3.12-2.69,3.9-7.22,3.78-11.33s-.92-8.28-.14-12.32c.47-2.47,1.53-4.8,2.11-7.25s.65-5.2-.72-7.31c-2-3.09-6.21-3.71-9.88-4-4.17-.36-7.9.1-10.56-3.41a39.09,39.09,0,0,0-4.2-5.14C902.33,273,897,269.7,897,269.48Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#512e4e"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M788.28,480.36l-10.44-19.31-3.31,29.8s1.84,13.24,1.47,15.27,7.54,20.23,7.54,20.23,26.13,46.55,36.8,48.94l36-25.76-9.56-12.14s-3.31-1.29-4.14,0c0,0-17.76-30.54-19.59-32.74s-1.48-6.63-1.48-6.63-2.76-2.94-1.84-5.7S814.45,480,814.45,480l5.7-5.33Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M778.39,458.84l-2.76,2.21-3.31,29.8s1.84,13.24,1.47,15.27,7.55,20.23,7.55,20.23,26.12,46.55,36.79,48.94l36.06-25.76-9.57-12.14s-3.31-1.29-4.14,0c0,0-17.75-30.54-19.59-32.74s-1.47-6.63-1.47-6.63-2.76-2.94-1.84-5.7S812.24,480,812.24,480l5.7-5.33Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M949.66,575.62c2,2.43.74,13.35.74,13.35l-5.52,9.13s.33,5.9.35,13.86l-9.28,2.9a5.52,5.52,0,0,1-7.16-5.44l1.61-51.6,21.65,8.27c-1.84,1.28.18,4.42.18,4.42S947.64,573.19,949.66,575.62Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M950.76,574.52c2,2.42.74,13.34.74,13.34L946,597s.33,5.89.36,13.85l-9.45,2.95a5.39,5.39,0,0,1-7-5.31l1.61-51.78L953.16,565c-1.85,1.28.17,4.42.17,4.42S948.74,572.09,950.76,574.52Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M957.94,549.9s-1.47,9.39-5.15,9.94-5.33,15.19-9,14.68-1.24-13.62-1.11-16.16-4-13.06-.92-15.45,12.88,0,12.88,0Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#cf6f80"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M965.72,477.6l6.93-14s2.77,10.67,2.77,16.37,3.86,6.26,3.86,6.26,4.23,5,2,8.65-3.12,12.69-3.12,12.69.73,17.29-2.58,19.68-4.05,8.1-4.05,8.1-6.07,10.85-5.88,13.43-8.46,20.05-8.46,20.05,4.23-21.71-20.42-31.09c0,0-.19-7.36,1.65-9.38s4.71-3,2.91-13.16-.52-22.41-.52-24.86,5.52-17.72,5.52-17.72Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M968.8,461.6l6.06,2s2.77,10.67,2.77,16.37,3.86,6.26,3.86,6.26,4.23,5,2,8.65-3.13,12.69-3.13,12.69.74,17.29-2.57,19.68-4,8.1-4,8.1-6.07,10.85-5.88,13.43-8.47,20.05-8.47,20.05,4.23-21.71-20.42-31.09c0,0-.18-7.36,1.66-9.38s4.71-3,2.91-13.16-.52-22.41-.52-24.86,5.52-17.72,5.52-17.72Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#fff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M834.92,824.47s9.66-6.07,16-1.66S834.92,824.47,834.92,824.47Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M910,805.7s8.55-1.1,15.73,6.63S910,805.7,910,805.7Z",
    transform: "translate(-15.95 -18.56)",
    opacity: 0.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.49,322.09c-1.23,1.07-2.81,1.82-3.63,3.23-.7,1.21-.72,2.71-1.28,4s-2.19,2.36-3.33,1.54c-.26-9-4.69-17.45-10.14-24.65a25.57,25.57,0,0,0-5.49-5.69,10.75,10.75,0,0,0-7.47-2.12c-3,.41-5.64,2.45-8.67,2.71-4,.33-7.59-2.44-11.56-2.57a11.28,11.28,0,0,0-8.48,3.94,23.16,23.16,0,0,0-4.55,8.43,49.44,49.44,0,0,0-2.54,14.56c-.06,2.79-.32,6.27-2.9,7.31a13.84,13.84,0,0,1,0,2.23c2.61-1,2.87-4.53,2.93-7.33a49.44,49.44,0,0,1,2.54-14.56,23.16,23.16,0,0,1,4.55-8.43,11.32,11.32,0,0,1,8.48-3.95c4,.14,7.6,2.91,11.56,2.57,3-.25,5.66-2.29,8.67-2.7a10.75,10.75,0,0,1,7.47,2.11,25.62,25.62,0,0,1,5.49,5.7c5.45,7.2,9.88,15.62,10.14,24.65,1.14.82,2.77-.26,3.33-1.54s.58-2.78,1.28-4c.82-1.41,2.4-2.17,3.63-3.23,3.12-2.69,3.9-7.22,3.78-11.33,0-.13,0-.25,0-.38C926.1,316.17,925.15,319.8,922.49,322.09Z",
    transform: "translate(-15.95 -18.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.66,321.39c-2.29-2.53-5.43-4.23-7.54-6.91a14.51,14.51,0,0,1-2.91-8.18,15.41,15.41,0,0,0,2.91,10.39c2.11,2.68,5.25,4.37,7.54,6.9a15,15,0,0,1,3.78,8.92A15,15,0,0,0,848.66,321.39Z",
    transform: "translate(-15.95 -18.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.24,291.19c-.59,2.45-1.64,4.78-2.12,7.25a23.15,23.15,0,0,0-.31,5.06,19.41,19.41,0,0,1,.31-2.85c.48-2.47,1.53-4.8,2.12-7.25a12.56,12.56,0,0,0,.33-4.14A13.9,13.9,0,0,1,928.24,291.19Z",
    transform: "translate(-15.95 -18.56)"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.73,
    cy: 823.23,
    rx: 97.44,
    ry: 15.65,
    fill: "#00b0ff",
    opacity: 0.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 129.6,
    y: 523.42,
    width: 6.27,
    height: 141.17,
    fill: "#535461"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M191.23,682.73l-.4,6.36-.55,9-.23,3.74-.56,9-.24,3.74-.55,9-6.33,102.07a17.28,17.28,0,0,1-17.25,16.22H132.25A17.27,17.27,0,0,1,115,825.57L108.67,723.5l-.55-9-.23-3.74-.57-9-.23-3.74-.55-9-.4-6.36a9,9,0,0,1,8.94-9.51H182.3A9,9,0,0,1,191.23,682.73Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.88 670.52 174.32 679.5 91.14 679.5 90.58 670.52 174.88 670.52",
    fill: "#9d9cb5"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.09 683.24 173.54 692.22 91.93 692.22 91.37 683.24 174.09 683.24",
    fill: "#9d9cb5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "173.3 695.97 172.75 704.94 92.72 704.94 92.16 695.97 173.3 695.97",
    fill: "#9d9cb5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M97,594.9c36.52,26.42,51.73,67.74,51.73,67.74s-44-1.51-80.53-27.93S16.44,567,16.44,567,60.44,568.48,97,594.9Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44,567s45.67,25.35,60.32,46.34,71.93,49.32,71.93,49.32",
    transform: "translate(-15.95 -18.56)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M120.53,541.68c19.88,14.37,28.16,36.86,28.16,36.86s-24-.82-43.83-15.19S76.7,526.48,76.7,526.48,100.66,527.3,120.53,541.68Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7,526.48s24.86,13.8,32.84,25.22,39.15,26.84,39.15,26.84",
    transform: "translate(-15.95 -18.56)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M177.57,577.4c-22.83,25.09-27.66,57.88-27.66,57.88s32.19-7.9,55-33,27.66-57.88,27.66-57.88S200.4,552.31,177.57,577.4Z",
    transform: "translate(-15.95 -18.56)",
    fill: "#00b0ff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M232.59,544.41s-29.74,25.72-37.3,43.44-45.38,47.43-45.38,47.43",
    transform: "translate(-15.95 -18.56)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDoctor1);
export default __webpack_public_path__ + "static/media/newDoctor1.a4a8bdccea06962bcacedf60bec1dec5.svg";
export { ForwardRef as ReactComponent };